import AgoraRTC, { ICameraVideoTrack, IMicrophoneAudioTrack } from 'agora-rtc-react'
import { createContext, FC, PropsWithChildren } from 'react'

// Define the shape of the Agora context
type AgoraContextType = PropsWithChildren<{
  localCameraTrack: ICameraVideoTrack | null
  localMicrophoneTrack: IMicrophoneAudioTrack | null
}>

AgoraRTC.setLogLevel(1)

// Create the Agora context
const AgoraContext = createContext<AgoraContextType | null>(null)

// AgoraProvider component to provide the Agora context to its children
export const AgoraProvider: FC<AgoraContextType> = ({ children, localCameraTrack, localMicrophoneTrack }) => (
  <AgoraContext.Provider value={{ localCameraTrack, localMicrophoneTrack, children }}>{children}</AgoraContext.Provider>
)
